import React, { useState, useEffect, useRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

export default function(props){
    const [skill, setSkill] = useState('');
    const [visibility, setVisibility] = useState(false)

    function addAndClean(skill){
        if(skill === ''){
            setVisibility(true);
        }else{
            props.addCustomSkill(props.type, skill)
            setSkill('');
            setVisibility(false);
        }
    }
    return(
        <>
        
            <div className="add__custom">
                <TextareaAutosize
                    placeholder="Add a skill that we might have missed"
                    onChange={(e) => setSkill(e.target.value)}
                    value={skill}
                    className='resize-none p-1 ml-3 w-[90%]'
                />
                <div className="text__center btn btn__primary btn__rounded btn__md" onClick={() => addAndClean(skill)}>
                    <span className="material-icons font__30">
                        add
                    </span>
                </div>
            </div>
            {visibility &&
                <div>Please provide a value</div>
            }
            
        </>


    )
}